import { ALCHEMY } from '../data/alchemy.js';
import { BIOME_IDS } from '../data/biomes.js';
import { UPGRADE_MATERIAL_RARITIES, UPGRADE_MATERIALS } from '../data/upgrade-materials.js';
import { UPGRADE_STEPS } from '../data/upgrades.js';
import { fusionResult } from './fusion.js';
import { recipesAt } from './alchemy.js';
function buildIndex() {
    const index = new Map();
    const add = (templateId, use) => {
        const uses = index.get(templateId) ?? [];
        uses.push(use);
        index.set(templateId, uses);
    };
    for (const biome of BIOME_IDS) {
        for (const rarity of UPGRADE_MATERIAL_RARITIES) {
            const levels = UPGRADE_STEPS.filter((step) => step.material === rarity).map((s) => s.level);
            if (levels.length === 0)
                continue;
            add(UPGRADE_MATERIALS[biome][rarity].id, {
                kind: 'upgrade',
                biome,
                from: Math.min(...levels),
                to: Math.max(...levels),
            });
        }
    }
    for (const biome of Object.keys(ALCHEMY)) {
        for (const recipe of recipesAt(biome)) {
            for (const ingredient of recipe.ingredients) {
                add(ingredient.templateId, {
                    kind: 'alchemy',
                    potion: recipe.potion,
                    biome,
                    quantity: ingredient.quantity,
                });
            }
        }
    }
    return index;
}
const USES = buildIndex();
/** Every use of this item, crafting tables first; empty when it only sells. */
export function itemUses(template) {
    const uses = [...(USES.get(template.id) ?? [])];
    const fused = fusionResult(template);
    if (fused !== undefined)
        uses.push({ kind: 'fusion', result: fused.id });
    return uses;
}
//# sourceMappingURL=item-uses.js.map